import React from "react";
import t from "../../../../../../i18n";
import useVisibleSeries from "@ui/Highcharts/hooks/useVisibleSeries";
import PerformanceIndicatorSelector from "../../../PerformanceIndicatorSelector";
import ReportingPeriodSelector from "../../../ReportingPeriodSelector";
import ProjectAggregation from "../ProjectAggregationSelector";
import ReportingChart from "../../../ReportingChart";
import { useOptions } from "./useOptions";
import { useSeries } from "./useSeries";
import { useTranslations } from "../../../../../../api/useTranslations";
import type { PerformanceReporting } from "../../../../../../api/useReporting";

function FleetInternalLossesEvolution({ reporting }: { reporting: PerformanceReporting }) {
  const translations = useTranslations();
  const chart = React.useRef<Highcharts.Chart>(null);
  const series = useSeries(reporting);

  const chartDefinition = React.useMemo(
    () => ({
      id: "FleetPerProjectInternalLossesEvolution",
      title: t("reporting.internal_gaps_evolution.title", translations),
      description: {
        title: t("reporting.chart.info.title"),
        description: t("reporting.internal_gaps_evolution.info.description", translations),
        options: [
          {
            value: "INTERNAL_GAPS_OPTION",
            label: t("reporting.internal_gaps", translations),
            description: t("reporting.internal_gaps.description"),
          },
        ],
      },
    }),
    [translations],
  );

  const [visibleSeries] = useVisibleSeries(chartDefinition.id, series);
  const options = useOptions(chart, {
    reporting,
    reportingPeriod: reporting.range,
    series: visibleSeries,
  });

  return (
    <ReportingChart
      chartRef={chart}
      reporting={reporting}
      id={chartDefinition.id}
      title={chartDefinition.title}
      description={chartDefinition.description}
      series={series}
      options={options}
      leftOptions={
        <>
          <ProjectAggregation />
          <PerformanceIndicatorSelector reporting={reporting} />
        </>
      }
      rightOptions={
        <>
          <ReportingPeriodSelector reporting={reporting} />
        </>
      }
    />
  );
}

export default React.memo(FleetInternalLossesEvolution);
